import { Component, OnInit } from '@angular/core';
import { AuthState } from '@app/auth/store';
import { FetchProfilePicture, SetProfilePicture } from '@app/profile/store';
import { MetaService } from '@core/services';
import { Store } from '@ngxs/store';

@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {
  constructor(
    private metaService: MetaService,
    private store: Store
  ) {}

  ngOnInit(): void {
    this.metaService.init();
    this.store.select(AuthState.isAuthenticated).subscribe((isAuthenticated) => {
      if (isAuthenticated) {
        this.store.dispatch(new FetchProfilePicture(true));
      } else {
        this.store.dispatch(new SetProfilePicture());
      }
    });
  }
}
